import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { EducationItem, Education, EducationExitDate } from '../models';

export class EducationApi extends ApiModule {
  protected endpoint = '/education';

  public async pageEducations(params: any) {
    return this.api.post<PaginatedResponseData<EducationItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadEducationDetails(id: number) {
    return this.api.get<Education>(`${this.endpoint}?id=${id}`);
  }

  public saveEducation(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteEducation(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }

  public getList(personId: number) {
    return this.api.get<Education[]>(`${this.endpoint}/list?personId=${personId}`);
  }

  public loadPartExamByEducation(educationId: number) {
    return this.api.get<any[]>(`${this.endpoint}/list-part-exams?educationId=${educationId}`);
  }

  public loadEducationElementByEducation(educationId: number) {
    return this.api.get<any[]>(`${this.endpoint}/list-education-elements?educationId=${educationId}`);
  }

  public loadTutorReportEducationExitDate(id: number) {
    return this.api.get<EducationExitDate>(`${this.endpoint}/load-education-exit-date?educationId=${id}`);
  }
}
